// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.erl-partner-login-header {
    background-color: #1f1f1f;
    padding: 20px;
    line-height: 0;
}

.erl-partner-login-header img {
    max-width: 290px;
}

.erl-partner-login-content {
    text-align: center;
}

.erl-partner-login-content {
    text-align: center;
    color: #8d2432;
    background-color: #f7f7f7;
    padding: 30px 15px;
}

.partner-login-label {
    margin: 30px 0 8px;
    font-family: "franklingothic-demi", Helvetica, Arial, sans-serif;
    font-size: .8em;
}

.partner-login-label-first {
    margin-top: 0;
}

.arrow-button {
    background-image: none;
    background-color: #8d2432;
    border-radius: 0;
    position: relative;
    padding: 15px 60px 15px 40px;
    color: white;
}

.arrow-button:hover {
    opacity: .95;
}

.arrow-button::after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
     transform: translateY(-50%);
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 20px solid #8d2532;
    background-color: #f7f7f7;
}

.avia-button.avia-color-dark.become-partner {
    color: #8d2532 !important;
    border-color: #8d2532 !important;
}`, "",{"version":3,"sources":["webpack://./../css/react-partner-portal-login.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gEAAgE;IAChE,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,QAAQ;KACP,2BAA2B;IAC5B,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC","sourcesContent":[".erl-partner-login-header {\n    background-color: #1f1f1f;\n    padding: 20px;\n    line-height: 0;\n}\n\n.erl-partner-login-header img {\n    max-width: 290px;\n}\n\n.erl-partner-login-content {\n    text-align: center;\n}\n\n.erl-partner-login-content {\n    text-align: center;\n    color: #8d2432;\n    background-color: #f7f7f7;\n    padding: 30px 15px;\n}\n\n.partner-login-label {\n    margin: 30px 0 8px;\n    font-family: \"franklingothic-demi\", Helvetica, Arial, sans-serif;\n    font-size: .8em;\n}\n\n.partner-login-label-first {\n    margin-top: 0;\n}\n\n.arrow-button {\n    background-image: none;\n    background-color: #8d2432;\n    border-radius: 0;\n    position: relative;\n    padding: 15px 60px 15px 40px;\n    color: white;\n}\n\n.arrow-button:hover {\n    opacity: .95;\n}\n\n.arrow-button::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 50%;\n    right: 0;\n     transform: translateY(-50%);\n    border-top: 25px solid transparent;\n    border-bottom: 25px solid transparent;\n    border-left: 20px solid #8d2532;\n    background-color: #f7f7f7;\n}\n\n.avia-button.avia-color-dark.become-partner {\n    color: #8d2532 !important;\n    border-color: #8d2532 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
